module.exports = __webpack_public_path__ + "static/assets/45b0dd958c1703fd47eb4fb3e3b24e4b.svg";